import { logger } from '@/util';
import callBackendApi from './call';

export type CacheName = 'redis.All' | 'redis.ListContact' | 'redis.AdvancedSearch' | 'memory.all';

export const clearCache = async (token: string, cacheName: CacheName) => {
  logger.debug('clearCache() called', { cacheName });

  const data = await callBackendApi({
    token,
    method: 'post',
    endpoint: `/dev/clearcache?cache=${cacheName}`,
  });

  return data;
};
